
import { defineComponent, defineAsyncComponent, PropType } from "vue";
import GameButton from "@/components/GameButton.vue";
import type { ActionButtonOptions } from "@/data/types";
import Countdown from "@/data/Countdown";
import ActionButton from "@/components/ActionButton.vue";
import { gamesPointThresholds } from "@/data/games";
import Modal from "@/components/Modal.vue";

export default defineComponent({
  name: "GameWrapper",

  components: {
    GameButton,
    ActionButton,
    Modal,
  },

  data() {
    return {
      preCountdown: new Countdown(3) as Countdown,
      preTimer: 0,
      gamesPointThresholds,
      isHelpModalOpen: false,
    };
  },

  props: {
    actionButtons: {
      type: Array as PropType<ActionButtonOptions[]>,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    points: {
      type: Number,
      default: 0,
    },
    isGameOver: {
      type: Boolean,
      required: true,
    },
    counter: {
      type: Number,
      required: true,
    },
  },

  beforeMount() {
    document.addEventListener("keydown", this.handleKeyDown, false);
  },

  beforeUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown, false);
  },

  computed: {
    gameHelperComponent() {
      return defineAsyncComponent(
        () => import(`@/components/gameHelp/${this.name}Help.vue`)
      );
    },
    isPreCountdownRunning(): boolean {
      return this.preCountdown.isRunning;
    },
    isFirstGame(): boolean {
      return this.counter < 1;
    },
    pointsClass(): string {
      let thresholdOptions = this.gamesPointThresholds[this.name];
      if (thresholdOptions && thresholdOptions.type === "absolute") {
        let thresholds = thresholdOptions.thresholds;
        if (this.points < thresholds[0]) {
          return "color--red";
        } else if (
          this.points >= thresholds[0] &&
          this.points < thresholds[1]
        ) {
          return "color--white";
        } else if (
          this.points >= thresholds[1] &&
          this.points < thresholds[2]
        ) {
          return "color--green";
        } else if (
          this.points >= thresholds[2] &&
          this.points < thresholds[3]
        ) {
          return "color--blue";
        } else {
          return "color--violet";
        }
      } else {
        return "color--white";
      }
    },
  },

  methods: {
    handleKeyDown(event: KeyboardEvent) {
      switch (event.code) {
        case "KeyB":
          event.preventDefault();
          this.$router.push("/");
          break;
        case "KeyR":
        case "KeyS":
          event.preventDefault();
          this.$emit("restart");
          break;
      }
      this.actionButtons.forEach((button) => {
        if (button.code && button.code === event.code) {
          event.preventDefault();
          this.$emit(button.clickEvent.event, button.clickEvent.value);
        }
      });
    },
    openModal() {
      this.isHelpModalOpen = true;
    },
  },

  watch: {
    counter(newVal, oldVal) {
      if (newVal > oldVal) {
        this.preCountdown.reset();
        this.preCountdown.start();
      }
    },
    preCountdown: {
      deep: true,
      handler(newVal) {
        if (newVal.isOver) {
          this.$emit("precountdown-over");
        }
      },
    },
  },
});
